<script>
  import { stringifyStyle, calcPxNum } from './utils'
  export let width = undefined
  export let height = undefined
  export let maxWidth = undefined
  export let maxHeight = undefined
  export let url
  export let alt = ''
  export let radius = 0
  export let cursor = undefined

  $: style = {
    width: calcPxNum(width),
    height: calcPxNum(height),
    max_width: calcPxNum(maxWidth),
    max_height: calcPxNum(maxHeight),
    border_radius: calcPxNum(radius),
    display: 'block', // solve parent div higher than image, fuck
    cursor: cursor,
  }

</script>

<img 
  style={stringifyStyle(style)}
  src={url}
  alt={alt}
  on:click
  on:keypress
/>